import Promise from 'promise-polyfill';
import Utils from './Utils';

export default class ComponentHandler {
	constructor(classes) {
		this.classes = classes;
		this.elements = [];
		this.components = [];
		this.dependencies = [];
		window.components = this;
		Utils.onDomUpdate(() => {
			this.initComponents();
		});
	}

	addClasses(classes) {
		this.classes = Object.assign(this.classes, classes);
	}

	/**
	 * @return {Promise}
	 */
	initComponents() {
		return Promise.all(
			Array.from(document.querySelectorAll('[data-component]'))
				.filter(el => this.elements.indexOf(el) === -1) // Is already initialized?
				.map(element => this
					.processElement(element)
					.then(items => items.forEach(item => Utils.log(`Component: ${item.type}`, item.element, item.component)))
					.catch(e => console.error(e))),
		);
	}

	/**
	 * @param {HTMLElement} element
	 * @return {Promise}
	 */
	processElement(element) {
		return this
			.loadDependenciesFor(element)
			.then(() => this.createComponentsFor(element));
	}


	/**
	 * @param {HTMLElement} element
	 * @return {Promise}
	 */
	loadDependenciesFor(element) {
		const urls = element.hasAttribute('data-component-deps')
			? element.getAttribute('data-component-deps').split(';')
			: [];

		return Promise.all(
			urls
				// Remove spaces
				.map(url => url.trim())
				// Is already loaded?
				.filter(url => url.length > 0 && this.dependencies.indexOf(url) === -1)
				// If not => load
				.map(url => Utils.loadAsset(url)),
		);
	}

	/**
	 * @param {HTMLElement} element
	 * @return {Promise}
	 */
	createComponentsFor(element) {
		return Promise.all(
			element.getAttribute('data-component').split(',')
				.map((type) => {
					if (!this.classes[type]) {
						throw new Error(
							`ComponentHandler: component type ${type} not found. 
							Check ComponentHandler constructor or add component class with addClass(...).`,
						);
					}

					const component = new this.classes[type](element, ComponentHandler.getData(element));
					this.elements.push(element);
					this.components.push(component);

					return {
						element,
						type,
						component,
					};
				}),
		);
	}

	/**
	 * Get all data-* attributes as object and parse JSON values
	 * @param {HTMLElement} element
	 * @return {object}
	 */
	static getData(element) {
		const data = {};
		const dataset = element.dataset;
		Object.keys(dataset).forEach((key) => {
			let value = dataset[key];

			try {
				value = JSON.parse(value);
			} catch (e) {
				// not JSON, use raw value
			}

			data[key] = value;
		});

		return data;
	}
}
